import React from 'react';
import { SeverityProps } from './types';
import { Container } from './styles';

const Severity: React.FC<SeverityProps> = ({ severity }) => {
  let color = '#1890FF';
  let severityName = 'Não informado';

  switch (severity) {
    case 'URGENTE':
      color = '#F5222D';
      severityName = 'Urgente';
      break;
    case 'ALTA':
      color = '#FA8C16';
      severityName = 'Alta';
      break;
    case 'MEDIA':
      color = '#52C41A';
      severityName = 'Média';
      break;
    case 'BAIXA':
      color = '#939195';
      severityName = 'Baixa';
      break;
    default:
      break;
  }

  return <Container data-cy="priority" color={color}>{severityName}</Container>;
};

export default Severity;
